import _has from 'lodash/has'
// import _forEach from 'lodash/forEach'

export const customerGroups = {
  namespaced: true,
  state: () => ({
    error: null,
    customerGroups: []
  }),
  getters: {
    customerGroups (state) {
      return state.customerGroups
    }
  },
  mutations: {
    customerGroupsLoaded: function (state, customerGroups) {
      state.error = null
      state.customerGroups = customerGroups
    }
  },
  actions: {
    loadCustomerGroups ({ commit, dispatch }) {
      return this.$app.axios.get('/customergroup/get', {
      }).then(function (response) {
        // Erfolgreiche Authentifizierung
        commit('customerGroupsLoaded', response.data)
      })
        .catch((error) => {
          // Es soll trotz eines 401 den Error aus dem Response Body angezeigt werden
          if (error.response && error.response.status === 401) {
            const data = error.response.data
            if (_has(data, 'message')) {
              commit('authenticatingError', data.message)
            } else {
              // Sollte nicht eintreten, malformed json response
              commit('authenticatingError', error)
            }
          } else {
            // Anderer HTTP-Status-Code (zum Beispiel 500)
            commit('authenticatingError', error)
          }
        })
    }
  }
}
